import { DefaultRole } from 'app/area/administration/shared/types';
import { Person, AccessPerson, AccessItem, ExtraInfoCodeValues } from 'app/components/access-panel/shared/types';
import { Value } from 'app/types-shared';

export const ACTION = {
  REQUEST_LOAD_ROLE: 'ADMINISTRATION_EDIT_ROLE:REQUEST_LOAD_ROLE',
  RECEIVE_LOAD_ROLE: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_LOAD_ROLE',
  FAIL_LOAD_ROLE: 'ADMINISTRATION_EDIT_ROLE:FAIL_LOAD_ROLE',
  REQUEST_LOAD_ROLE_ACCESS: 'ADMINISTRATION_EDIT_ROLE:REQUEST_LOAD_ROLE_ACCESS',
  RECEIVE_LOAD_ROLE_ACCESS: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_LOAD_ROLE_ACCESS',
  FAIL_LOAD_ROLE_ACCESS: 'ADMINISTRATION_EDIT_ROLE:FAIL_LOAD_ROLE_ACCESS',
  REQUEST_ADD_ROLE: 'ADMINISTRATION_EDIT_ROLE:REQUEST_ADD_ROLE',
  RECEIVE_ADD_ROLE: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_ADD_ROLE',
  REQUEST_UPDATE_ROLE: 'ADMINISTRATION_EDIT_ROLE:REQUEST_UPDATE_ROLE',
  RECEIVE_UPDATE_ROLE: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_UPDATE_ROLE',
  FAIL_ROLE_SAVE: 'ADMINISTRATION_EDIT_ROLE:FAIL_ROLE_SAVE',
  REQUEST_ROLE_DELETE: 'ADMINISTRATION_EDIT_ROLE:REQUEST_ROLE_DELETE',
  REQUEST_EXTRA_INFO: 'ADMINISTRATION_EDIT_ROLE:REQUEST_EXTRA_INFO',
  RECEIVE_EXTRA_INFO: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_EXTRA_INFO',
  FAIL_EXTRA_INFO: 'ADMINISTRATION_EDIT_ROLE:FAIL_EXTRA_INFO',
  REQUEST_PERSON_OPTIONS: 'ADMINISTRATION_EDIT_ROLE:REQUEST_PERSON_OPTIONS',
  RECEIVE_PERSON_OPTIONS: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_PERSON_OPTIONS',
  FAIL_PERSON_OPTIONS: 'ADMINISTRATION_EDIT_ROLE:FAIL_PERSON_OPTIONS',
  PROCESS_ROLE_FAILED: 'ADMINISTRATION_EDIT_ROLE:PROCESS_ROLE_FAILED',
  CLEAR_ROLE_DATA: 'ADMINISTRATION_EDIT_ROLE:CLEAR_ROLE_DATA',
  CLEAR_VALIDATION: 'ADMINISTRATION_EDIT_ROLE:CLEAR_VALIDATION',
  UPDATE_ACCESS_DATA: 'ADMINISTRATION_EDIT_ROLE:UPDATE_ACCESS_DATA',
  REQUEST_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_ROLE:REQUEST_DEFAULT_ROLE',
  RECEIVE_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_DEFAULT_ROLE',
  FAIL_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_ROLE:FAIL_DEFAULT_ROLE',
  REQUEST_SET_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_ROLE:REQUEST_SET_DEFAULT_ROLE',
  RECEIVE_SET_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_ROLE:RECEIVE_SET_DEFAULT_ROLE',
  FAIL_SET_DEFAULT_ROLE: 'ADMINISTRATION_EDIT_ROLE:FAIL_SET_DEFAULT_ROLE',
  CHANGE_DEFAULT_ROLE_MARK: 'ADMINISTRATION_EDIT_ROLE:CHANGE_DEFAULT_ROLE_MARK'
};

export class RequestAddRole {
  public type: string = ACTION.REQUEST_ADD_ROLE;
}

export class ReceiveAddRole {
  public type: string = ACTION.RECEIVE_ADD_ROLE;
}

export class RequestUpdateRole {
  public type: string = ACTION.REQUEST_UPDATE_ROLE;
}

export class ReceiveUpdateRole {
  public type: string = ACTION.RECEIVE_UPDATE_ROLE;
}

export class FailRoleExecute {
  public type: string = ACTION.FAIL_ROLE_SAVE;
}

export class RequestRoleDelete {
  public type: string = ACTION.REQUEST_ROLE_DELETE;
}

export class RequestLoadRole {
  public type: string = ACTION.REQUEST_LOAD_ROLE;
}

export class ReceiveLoadRole {
  public type: string = ACTION.RECEIVE_LOAD_ROLE;
  public data: Person;

  constructor(data: Person) {
    this.data = data;
  }
}

export class FailLoadRole {
  public type: string = ACTION.FAIL_LOAD_ROLE;
}

export class RequestLoadRoleAccess {
  public type: string = ACTION.REQUEST_LOAD_ROLE_ACCESS;
}

export class ReceiveLoadRoleAccess {
  public type: string = ACTION.RECEIVE_LOAD_ROLE_ACCESS;
  public accessPerson: AccessPerson;

  constructor(accessPerson: AccessPerson) {
    this.accessPerson = accessPerson;
  }
}

export class FailLoadRoleAccess {
  public type: string = ACTION.FAIL_LOAD_ROLE_ACCESS;
}

export class RequestExtraInfo {
  public type: string = ACTION.REQUEST_EXTRA_INFO;
}

export class ReceiveExtraInfo {
  public type: string = ACTION.RECEIVE_EXTRA_INFO;
  constructor(public values: ExtraInfoCodeValues[]) { }
}

export class FailExtraInfo {
  public type: string = ACTION.FAIL_EXTRA_INFO;
}

export class RequestPersonOptions {
  public type: string = ACTION.REQUEST_PERSON_OPTIONS;
}

export class ReceivePersonOptions {
  public type: string = ACTION.RECEIVE_PERSON_OPTIONS;
  constructor(public values: Value[]) { }
}

export class FailPersonOptions {
  public type: string = ACTION.FAIL_PERSON_OPTIONS;
}

export class ProcessRoleFailed {
  public type: string = ACTION.PROCESS_ROLE_FAILED;
  public errors: any;
  constructor(errors: any) {
    this.errors = errors;
  }
}

export class ClearRoleData {
  public type: string = ACTION.CLEAR_ROLE_DATA;
}

export class ClearValidation {

  public type: string = ACTION.CLEAR_VALIDATION;

  constructor(public formName: string,
    public parameters: { [key: string]: number | string }) {
  }
}

export class UpdateAccessData {
  public type: string = ACTION.UPDATE_ACCESS_DATA;
  public key: string;
  public accessItem: Partial<AccessItem>;

  constructor(key: string, accessItem: Partial<AccessItem>) {
    this.key = key;
    this.accessItem = accessItem;
  }
}

export class RequestDefaultRole {
  public type: string = ACTION.REQUEST_DEFAULT_ROLE;
}

export class ReceiveDefaultRole {
  public type: string = ACTION.RECEIVE_DEFAULT_ROLE;
  constructor(public defaultRole: DefaultRole, public markedAsDefaultRole: boolean) { }
}

export class FailDefaultRole {
  public type: string = ACTION.FAIL_DEFAULT_ROLE;
}

export class RequestSetDefaultRole {
  public type: string = ACTION.REQUEST_SET_DEFAULT_ROLE;
}

export class ReceiveSetDefaultRole {
  public type: string = ACTION.RECEIVE_SET_DEFAULT_ROLE;
}

export class FailSetDefaultRole {
  public type: string = ACTION.FAIL_SET_DEFAULT_ROLE;
}

export class ChangeDefaultRoleMark {
  public type: string = ACTION.CHANGE_DEFAULT_ROLE_MARK;
  constructor(public mark: boolean) { }
}
